export interface CreateProcess<TData> {
  Data: TData;
  Type: string;
}

export interface ProcessApiResponse<TData> {
  Id: number;
  Status: string;
  CompletedTime?: Date;
  CreatedDate: Date;
  Type: string;
  DisplayName: string;
  GroupId: string;
  States: ProcessState[];
  Data: TData;
  StatusCategory: SlotcheckStateStatusCategory;
  Triggers: ProcessTrigger[];
}

export interface ProcessInstancesNotesView {
  Id: number;
  StateId: string;
  Status: string;
  Type: string;
  DisplayName: string;
  GroupId: string;
  StatusCategory: SlotcheckStateStatusCategory;
  StatusStartTime: Date;
  LastActivityTime: Date;
  LastActivityById: number;
  CompletedTime?: Date;
  CreatedDate: Date;
  ProcessInstancesStatus: string;
  UserAuthFirstName: string;
  UserAuthLastName: string;
  Field1: string;
  Field2: string;
  Field3: string;
  Field4: string;
  Field5: string;
  ProcessInstancesId: number;
  SectionId: string;
  Notes: string;
}

export enum SlotcheckStateStatusCategory {
  Complete,
  InProgress,
  Error,
}

export enum WorkflowItemStatus {
  Inactive,
  Active,
  Complete,
}

export enum FieldSize {
  Small = 1,
  Normal = 2,
  Big = 3,
  Huge = 4,
}

export interface FieldDefinitionOptions {
  [option: string]: any;
  Required: boolean;
  Text: string;
  HelpText: string;
  Size: FieldSize;
}

export interface ValueFieldDefinitionOptions extends FieldDefinitionOptions {
  Min?: number;
  Max?: number;
}

export interface Field {
  WorkItemId: string;
  Status: "Inactive" | "Active";
  Valid: boolean;
  Options: FieldDefinitionOptions;
  Type: string;
  ChildrenBehavior: "Collection" | "Sequence";
  UserAuthorized: boolean;
  Children?: Field[];
  Value: any;
}

export interface ProcessState {
  Id: string;
  WorkflowItems?: Field[];
  Name: string;
  StatusCategory: "Complete" | "InProgress" | "Error" | "Cancelled";
  ParentStateId?: string;
  IsSubState?: boolean;
}

export type ProcessTriggerCategory = "Prominent" | "Normal";

export interface ProcessTrigger {
  Name: string;
  Permission?: string;
  Category: ProcessTriggerCategory;
  ConfirmationText?: string;
}

export interface WorkItemTypeConfig {
  name: string;
  formlyFieldType: string;
  size?: 1 | 2 | 3 | 4;
  customizer?: (field: Field) => void;
}
